import { OBtcWalletId, TNetworkMode, getOkxBtcWallet } from 'modules/api';
import {
  ConnectBtn,
  IConnectBtnProps,
} from 'modules/auth/components/ConnectBtn';
import { WalletIcon } from 'modules/auth/components/WalletIcon';
import { useBtcConnectBtnAdapter } from 'modules/auth/hooks/useBtcConnectBtnAdapter';
import { IS_PROD } from 'modules/common/const';
import { useTranslation } from 'modules/i18n';
import { translation } from './translation';

const walletId = OBtcWalletId.OKX;
const networkMode: TNetworkMode = IS_PROD ? 'mainnet' : 'testnet';

export function ConnectOKX({
  iconOnly,
}: Pick<IConnectBtnProps, 'iconOnly'>): JSX.Element {
  const { keys, t } = useTranslation(translation);

  const props = useBtcConnectBtnAdapter({
    walletId,
    isInjected: !!getOkxBtcWallet(networkMode),
  });

  return (
    <ConnectBtn
      {...props}
      iconOnly={iconOnly}
      title={t(keys.title)}
      iconSlot={<WalletIcon wallet={walletId} />}
    />
  );
}
